import { useQuery } from '@tanstack/react-query';
import type { AxiosResponse } from 'axios';

import type { ITemplate } from '@model/templateItem';

import { apiClient } from '@services/apiClient';

export const templatesListKey = () => ['templatesList'];

export const templatesListFn = () =>
  apiClient.get(`${APP_API_URL_V2}fsd/action-item/cost-savings-settings/template`);

export const templatesListSelect = ({ data }: AxiosResponse<{ data: Array<ITemplate> }>) => data?.data || [];

export const useTemplatesListQuery = () => {
  return useQuery({
    queryKey: templatesListKey(),
    queryFn: templatesListFn,
    select: templatesListSelect,
  });
};
